import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const isCustomSrc = !!src;
  const imageSrc = src || (icon ? "/branding/wacliscal-icon-dark.png" : "/branding/wacliscal-logo-horizontal-dark.png");

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {isCustomSrc ? (
          <img className={classNames(icon ? "mx-auto w-9" : (small ? "h-6 w-auto max-w-[180px] object-contain" : "h-8 w-auto max-w-[220px] object-contain"))} alt="WaclisCal" title="WaclisCal" src={imageSrc} />
        ) : (
          icon ? (
            <>
              <img className="mx-auto w-9 dark:hidden" alt="WaclisCal" title="WaclisCal" src="/branding/wacliscal-icon-light.png" />
              <img className="mx-auto w-9 hidden dark:block" alt="WaclisCal" title="WaclisCal" src="/branding/wacliscal-icon-dark.png" />
            </>
          ) : (
            <>
              <img
                className={classNames(small ? "h-6 w-auto max-w-[175px] object-contain" : "w-full max-w-[175px] h-auto object-contain", "dark:hidden")}
                alt="WaclisCal"
                title="WaclisCal"
                src="/branding/wacliscal-logo-horizontal-light.png"
                style={{ width: '100%', maxWidth: '175px', minWidth: '145px', objectFit: 'contain' }}
              />
              <img
                className={classNames(small ? "h-6 w-auto max-w-[175px] object-contain" : "w-full max-w-[175px] h-auto object-contain", "hidden dark:block")}
                alt="WaclisCal"
                title="WaclisCal"
                src="/branding/wacliscal-logo-horizontal-dark.png"
                style={{ width: '100%', maxWidth: '175px', minWidth: '145px', objectFit: 'contain' }}
              />
            </>
          )
        )}
      </strong>
    </h3>
  );
}
